// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","466":"component---src-pages-docs-mdx-slug-js"}[chunkId] + "-" + {"125":"d948df6ffc2a2bd814b0","293":"3dccc4da54986e095ec5","466":"e52fced22fcbe36f6ba1"}[chunkId] + ".js";
};